import $ from "jquery";
var BuyValue = /** @class */ (function () {
    function BuyValue() {
        $(".js-button").on("click", function () {
            var type = $(this).attr("data-type");
            $("[name=value]").val(type);
            $("form").submit();
        });
    }
    return BuyValue;
}());
export { BuyValue };
